import Modal from "components/modal";
import React from "react";
import { JA } from "utils/strings.ja";

export default function ModalConfirm({
  title = "",
  primaryButton = "",
  isOpen = false,
  closeModal = () => {},
  handleOk = () => {},
}) {
  return (
    <Modal
      title={title || JA.camera.delete}
      isOpen={isOpen}
      handleCloseModal={closeModal}
      primaryButton={primaryButton || JA.common.erase}
      primaryAction={handleOk}
      error={""}
      cancelText={JA.common.cancel}
    >
      <div>
        <div className="flex">
          <p className="block mb-2 font-medium text-slate-500 dark:text-white">
            {JA.user.confirmDelete}?
          </p>
        </div>
      </div>
    </Modal>
  );
}
